var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowLeftNoborder = function SvgArrowLeftNoborder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007CBA",
    fillRule: "nonzero",
    d: "M7.712 4a2.14 2.14 0 0 1-.284 2.927L4.996 9.045H19v1.913H4.996l2.432 2.116c.857.745.981 2.03.284 2.926L1 10l6.712-6z"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4NCiAgICA8cGF0aCBmaWxsPSIjMDA3Q0JBIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik03LjcxMiA0YTIuMTQgMi4xNCAwIDAgMS0uMjg0IDIuOTI3TDQuOTk2IDkuMDQ1SDE5djEuOTEzSDQuOTk2bDIuNDMyIDIuMTE2Yy44NTcuNzQ1Ljk4MSAyLjAzLjI4NCAyLjkyNkwxIDEwbDYuNzEyLTZ6Ii8+DQo8L3N2Zz4NCg==";
export { SvgArrowLeftNoborder as ReactComponent };